// extracted by mini-css-extract-plugin
export default {"containner":"CustomFieldItem_containner__zN8ja","containnerFull":"CustomFieldItem_containnerFull__9QRvA"};